import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'chitin-icon',
  templateUrl: './chitin-icon.component.html',
  styleUrls: ['./chitin-icon.component.scss'],
  imports: [CommonModule],
})
export class ChitinIconComponent {
  /** Prepend `asset:[PATH]` to use local icons in the `/assets` folder */
  icon = input.required<string>();
  faIcon = computed(() => (this.icon()?.startsWith('asset:') ? undefined : this.icon()));
  assetIcon = computed(() => {
    const icon = this.icon();
    return icon?.startsWith('asset:') ? `assets/${icon.slice(6)}` : undefined;
  });

  /** Doesn't work with `asset:` icons */
  color = input<'primary' | 'danger' | 'success' | 'secondary' | 'text' | 'lighter-blue' | 'pink' | 'white'>();

  clickable = input<boolean>();
  styles = input<Partial<CSSStyleDeclaration>>();
  size = input<'xs' | 'sm' | 'md' | 'lg'>('md');

  protected classes = computed<string>(() => {
    const colorClass = this.color() !== undefined ? `text-${this.color()}` : '';
    return this.faIcon() ? `${this.faIcon()}  icon-${this.size()} ${colorClass}` : `icon-${this.size()} ${colorClass}`;
  });
}
